import state from './group.state'
import mutations from './group.mutations'
import actions from './group.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
